module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-plus-fill-1ad4b410.svg";